
export const EDITOR_MODULES = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ["link", "image"],
    ["blockquote", "code-block"],
    ["clean"],
  ],
  keyboard: {
    bindings: {
      // Configuration sécurisée des raccourcis clavier
      tab: {
        key: 9,
        handler: function(range, context) {
          if (range.length === 0 && context.empty) {
            this.quill.insertText(range.index, "    ");
            return false;
          }
          return true;
        }
      },
      // Raccourcis personnalisés sécurisés
      'bold': {
        key: 'B',
        ctrlKey: true,
        handler: function(range, context) {
          this.quill.format('bold', !context.format.bold);
        }
      },
      'italic': {
        key: 'I',
        ctrlKey: true,
        handler: function(range, context) {
          this.quill.format('italic', !context.format.italic);
        }
      },
      'underline': {
        key: 'U',
        ctrlKey: true,
        handler: function(range, context) {
          this.quill.format('underline', !context.format.underline);
        }
      }
    }
  },
  clipboard: {
    // Améliorer la gestion du presse-papiers
    matchVisual: false,
  },
  history: {
    delay: 1000,
    maxStack: 100,
    userOnly: true
  }
};

// Formats autorisés - CORRIGÉS pour éviter les conflits
export const EDITOR_FORMATS = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline", 
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "color",
  "background",
  "align",
  "code-block",
  // Suppression de "script" qui cause les erreurs
];


// === FONCTIONS UTILITAIRES POUR LES IMAGES ===

/**
 * Créer la modal d'insertion d'image
 */
const createImageModal = (quillInstance) => {
  // Supprimer toute modal existante
  const existingModal = document.getElementById("quill-image-modal");
  if (existingModal) {
    existingModal.remove();
  }

  // Créer la modal
  const modal = document.createElement("div");
  modal.id = "quill-image-modal";
  modal.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  `;

  // Contenu de la modal
  modal.innerHTML = `
    <div style="
      background: white;
      border-radius: 12px;
      box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
      max-width: 500px;
      width: 90%;
      max-height: 90vh;
      overflow-y: auto;
      padding: 0;
    ">
      <div style="
        padding: 24px 24px 16px 24px;
        border-bottom: 1px solid #e5e7eb;
      ">
        <h3 style="
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #111827;
          display: flex;
          align-items: center;
        ">
          <svg style="width: 20px; height: 20px; margin-right: 8px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
          </svg>
          Insérer une image
        </h3>
        <p style="
          margin: 8px 0 0 0;
          color: #6b7280;
          font-size: 14px;
        ">
          Choisissez comment ajouter votre image
        </p>
      </div>

      <div style="padding: 24px;">
        <!-- Option 1: Upload de fichier -->
        <div style="margin-bottom: 24px;">
          <h4 style="
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: 500;
            color: #374151;
            display: flex;
            align-items: center;
          ">
            <svg style="width: 16px; height: 16px; margin-right: 6px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"/>
            </svg>
            Télécharger un fichier
          </h4>
          <div style="
            border: 2px dashed #d1d5db;
            border-radius: 8px;
            padding: 24px;
            text-align: center;
            background-color: #f9fafb;
            cursor: pointer;
            transition: all 0.2s;
          " id="drop-zone">
            <input type="file" id="file-input" accept="image/*" style="display: none;">
            <svg style="width: 32px; height: 32px; margin: 0 auto 12px auto; color: #9ca3af;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"/>
            </svg>
            <p style="margin: 0 0 4px 0; color: #374151; font-weight: 500;">
              Cliquez pour sélectionner ou glissez votre image ici
            </p>
            <p style="margin: 0; color: #6b7280; font-size: 12px;">
              PNG, JPG, GIF, WEBP (max. 5MB)
            </p>
          </div>
        </div>

        <!-- Séparateur -->
        <div style="
          display: flex;
          align-items: center;
          margin: 24px 0;
        ">
          <div style="flex: 1; height: 1px; background-color: #e5e7eb;"></div>
          <span style="padding: 0 16px; color: #6b7280; font-size: 14px;">ou</span>
          <div style="flex: 1; height: 1px; background-color: #e5e7eb;"></div>
        </div>

        <!-- Option 2: URL -->
        <div style="margin-bottom: 24px;">
          <h4 style="
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: 500;
            color: #374151;
            display: flex;
            align-items: center;
          ">
            <svg style="width: 16px; height: 16px; margin-right: 6px;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
            </svg>
            Insérer depuis une URL
          </h4>
          <input
            type="url"
            id="url-input"
            placeholder="https://example.com/image.jpg"
            style="
              width: 100%;
              padding: 12px;
              border: 1px solid #d1d5db;
              border-radius: 6px;
              font-size: 14px;
              transition: border-color 0.2s;
            "
          >
          <p style="margin: 8px 0 0 0; color: #6b7280; font-size: 12px;">
            L'image doit être accessible publiquement
          </p>
        </div>

        <!-- Prévisualisation -->
        <div id="image-preview" style="
          display: none;
          margin-bottom: 24px;
          text-align: center;
        ">
          <h4 style="
            margin: 0 0 12px 0;
            font-size: 16px;
            font-weight: 500;
            color: #374151;
          ">Aperçu</h4>
          <img id="preview-img" style="
            max-width: 100%;
            max-height: 200px;
            border-radius: 6px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
          ">
          <div style="margin-top: 8px;">
            <input
              type="text"
              id="alt-text"
              placeholder="Description de l'image (texte alternatif)"
              style="
                width: 100%;
                padding: 8px 12px;
                border: 1px solid #d1d5db;
                border-radius: 6px;
                font-size: 14px;
              "
            >
          </div>
        </div>

        <!-- Boutons d'action -->
        <div style="
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          margin-top: 24px;
        ">
          <button
            type="button"
            id="cancel-btn"
            style="
              padding: 10px 20px;
              border: 1px solid #d1d5db;
              background: white;
              color: #374151;
              border-radius: 6px;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s;
            "
          >
            Annuler
          </button>
          <button
            type="button"
            id="insert-btn"
            disabled
            style="
              padding: 10px 20px;
              border: none;
              background: #57a863;
              color: white;
              border-radius: 6px;
              font-size: 14px;
              font-weight: 500;
              cursor: pointer;
              transition: all 0.2s;
              opacity: 0.5;
            "
          >
            Insérer l'image
          </button>
        </div>
      </div>
    </div>
  `;

  // Configuration des événements
  setupImageModalEvents(modal, quillInstance);

  return modal;
};

/**
 * Configuration des événements de la modal
 */
const setupImageModalEvents = (modal, quillInstance) => {
  const fileInput = modal.querySelector("#file-input");
  const urlInput = modal.querySelector("#url-input");
  const dropZone = modal.querySelector("#drop-zone");
  const preview = modal.querySelector("#image-preview");
  const previewImg = modal.querySelector("#preview-img");
  const altText = modal.querySelector("#alt-text");
  const cancelBtn = modal.querySelector("#cancel-btn");
  const insertBtn = modal.querySelector("#insert-btn");

  let currentImageData = null;

  // Fermer la modal
  const closeModal = () => {
    modal.remove();
    console.log("Image insertion modal closed:", {
      timestamp: "2025-07-02 20:27:15",
      user: "HiQaody",
      action: "close_image_modal",
    });
  };

  // Validation d'URL d'image
  const isValidImageUrl = (url) => {
    try {
      new URL(url);
      return (
        /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i.test(url) ||
        /^data:image\//i.test(url)
      );
    } catch {
      return false;
    }
  };

  // Afficher la prévisualisation
  const showPreview = (src, fileName = "") => {
    previewImg.src = src;
    previewImg.onload = () => {
      preview.style.display = "block";
      insertBtn.disabled = false;
      insertBtn.style.opacity = "1";
      insertBtn.style.cursor = "pointer";

      // Pré-remplir le texte alternatif
      if (fileName) {
        altText.value = fileName.replace(/\.[^/.]+$/, ""); // Enlever l'extension
      }
    };
    previewImg.onerror = () => {
      alert("Impossible de charger l'image. Vérifiez l'URL ou le fichier.");
      preview.style.display = "none";
      insertBtn.disabled = true;
      insertBtn.style.opacity = "0.5";
    };
  };

  // Gestion du fichier
  const handleFile = (file) => {
    if (!file.type.startsWith("image/")) {
      alert("Veuillez sélectionner un fichier image valide.");
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      // 5MB
      alert("Le fichier est trop volumineux. Taille maximale : 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      currentImageData = {
        type: "file",
        src: e.target.result,
        file: file,
        fileName: file.name,
      };
      showPreview(e.target.result, file.name);

      console.log("Image file loaded:", {
        fileName: file.name,
        fileSize: file.size,
        fileType: file.type,
        timestamp: "2025-07-02 20:27:15",
        user: "HiQaody",
      });
    };
    reader.readAsDataURL(file);
  };

  // Events du fichier
  fileInput.addEventListener("change", (e) => {
    if (e.target.files && e.target.files[0]) {
      handleFile(e.target.files[0]);
      urlInput.value = ""; // Clear URL input
    }
  });

  // Drop zone
  dropZone.addEventListener("click", () => fileInput.click());

  dropZone.addEventListener("dragover", (e) => {
    e.preventDefault();
    dropZone.style.borderColor = "#57a863";
    dropZone.style.backgroundColor = "#f0fdf4";
  });

  dropZone.addEventListener("dragleave", (e) => {
    e.preventDefault();
    dropZone.style.borderColor = "#d1d5db";
    dropZone.style.backgroundColor = "#f9fafb";
  });

  dropZone.addEventListener("drop", (e) => {
    e.preventDefault();
    dropZone.style.borderColor = "#d1d5db";
    dropZone.style.backgroundColor = "#f9fafb";

    const files = e.dataTransfer.files;
    if (files && files[0]) {
      handleFile(files[0]);
      fileInput.value = ""; // Clear file input
      urlInput.value = ""; // Clear URL input
    }
  });

  // Gestion de l'URL
  urlInput.addEventListener("input", (e) => {
    const url = e.target.value.trim();
    if (url && isValidImageUrl(url)) {
      currentImageData = {
        type: "url",
        src: url,
      };
      showPreview(url);
      fileInput.value = ""; // Clear file input

      console.log("Image URL entered:", {
        url: url,
        timestamp: "2025-07-02 20:27:15",
        user: "HiQaody",
      });
    } else {
      preview.style.display = "none";
      insertBtn.disabled = true;
      insertBtn.style.opacity = "0.5";
      currentImageData = null;
    }
  });

  // Bouton annuler
  cancelBtn.addEventListener("click", closeModal);

  // Clic en dehors de la modal
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Échap pour fermer
  document.addEventListener("keydown", function escapeHandler(e) {
    if (e.key === "Escape") {
      closeModal();
      document.removeEventListener("keydown", escapeHandler);
    }
  });

  // Bouton insérer
  insertBtn.addEventListener("click", () => {
    if (currentImageData) {
      const range = quillInstance.getSelection(true);
      const alt = altText.value.trim() || "Image";

      // Insérer l'image
      quillInstance.insertEmbed(
        range.index,
        "image",
        currentImageData.src,
        "user"
      );

      // Ajouter attribut alt si possible
      setTimeout(() => {
        const images = quillInstance.root.querySelectorAll("img");
        const lastImage = images[images.length - 1];
        if (lastImage && lastImage.src === currentImageData.src) {
          lastImage.alt = alt;
          lastImage.title = alt;
        }
      }, 100);

      // Positionner le curseur après l'image
      quillInstance.setSelection(range.index + 1);

      console.log("Image inserted:", {
        type: currentImageData.type,
        alt: alt,
        fileName: currentImageData.fileName || "URL",
        position: range.index,
        timestamp: "2025-07-02 20:27:15",
        user: "HiQaody",
      });

      closeModal();
    }
  });
};


export const LOCALIZED_TEXTS = {
  label: {
    fr: "Français",
    en: "English",
    mg: "Malagasy",
  },
  placeholder: {
    fr: "Commencez à écrire votre contenu en français...",
    en: "Start writing your content in English...",
    mg: "Manomboka manoratra ny votoatinao amin'ny teny Malagasy...",
  },
  emptyContent: {
    fr: "Aucun contenu à afficher",
    en: "No content to display",
    mg: "Tsy misy votoatiny haseho",
  },
  navigation: {
    title: "Navigation",
    outline: "Plan du document",
    languages: "Langues",
    tools: "Outils",
    statistics: "Statistiques",
    settings: "Paramètres",
    shortcuts: "Raccourcis",
  },
  preview: {
    show: "Aperçu",
    hide: "Édition",
  },
  actions: {
    save: "Enregistrer",
    export: "Exporter",
    print: "Imprimer",
  },
  styles: {
    normal: "Normal",
    heading1: "Titre 1 (Partie)",
    heading2: "Titre 2 (Sous-partie)",
    heading3: "Titre 3",
    heading4: "Titre 4",
    quote: "Citation",
    code: "Code",
    figureCaption: "Légende figure",
    footnote: "Note bas de page",
  },
  shortcuts: {
    title: "Raccourcis clavier disponibles",
    basic: "Raccourcis de base",
    formatting: "Formatage",
    navigation: "Navigation",
    advanced: "Avancés",
    categories: {
      basic: [
        "Ctrl+Z : Annuler",
        "Ctrl+Y : Refaire",
        "Ctrl+S : Sauvegarder",
        "Ctrl+P : Imprimer",
        "Ctrl+A : Tout sélectionner",
        "Ctrl+C : Copier",
        "Ctrl+X : Couper",
        "Ctrl+V : Coller",
      ],
      formatting: [
        "Ctrl+B : Gras",
        "Ctrl+I : Italique",
        "Ctrl+U : Souligné",
        "Ctrl+Shift+D : Barré",
        "Ctrl+1/2/3 : Titres 1/2/3",
        "Ctrl+0 : Style normal",
        "Ctrl+L/E/R/J : Alignement",
      ],
      lists: [
        "Ctrl+Shift+L : Liste à puces",
        "Ctrl+Shift+N : Liste numérotée",
        "Tab : Indenter",
        "Shift+Tab : Désindenter",
      ],
      advanced: [
        "Ctrl+K : Insérer lien",
        "Ctrl+Shift+I : Insérer image",
        "Ctrl+= : Exposant",
        "Ctrl+Shift+= : Indice",
        "Ctrl+Home/End : Début/Fin doc",
      ],
    },
  },
};

export const STYLE_PRESETS = [
  {
    id: "normal",
    name: LOCALIZED_TEXTS.styles.normal,
    preview: "Aa",
    description: "Texte normal du document",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.format("header", false);
      quill.format("blockquote", false);
      quill.format("code-block", false);
    },
  },
  {
    id: "heading1",
    name: LOCALIZED_TEXTS.styles.heading1,
    preview: "T1",
    description: "Titre principal de partie",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.formatLine(range.index, range.length, "header", 1);
    },
  },
  {
    id: "heading2",
    name: LOCALIZED_TEXTS.styles.heading2,
    preview: "T2",
    description: "Sous-titre de partie",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.formatLine(range.index, range.length, "header", 2);
    },
  },
  {
    id: "heading3",
    name: LOCALIZED_TEXTS.styles.heading3,
    preview: "T3",
    description: "Titre de section",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.formatLine(range.index, range.length, "header", 3);
    },
  },
  {
    id: "heading4",
    name: LOCALIZED_TEXTS.styles.heading4,
    preview: "T4",
    description: "Titre de sous-section",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.formatLine(range.index, range.length, "header", 4);
    },
  },
  {
    id: "quote",
    name: LOCALIZED_TEXTS.styles.quote,
    preview: "❝",
    description: "Citation ou encadré",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.formatLine(range.index, range.length, "blockquote", true);
      quill.format("header", false);
    },
  },
  {
    id: "code",
    name: LOCALIZED_TEXTS.styles.code,
    preview: "</>",
    description: "Code ou texte technique",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.formatLine(range.index, range.length, "code-block", true);
      quill.format("header", false);
    },
  },
  {
    id: "figureCaption",
    name: LOCALIZED_TEXTS.styles.figureCaption,
    preview: "Fig",
    description: "Légende de figure ou d'image",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.format("header", false);
      quill.format("italic", true);
      quill.format("size", "small");
      quill.format("align", "center");
      // Ajouter une classe CSS personnalisée
      const [line] = quill.getLine(range.index);
      if (line) {
        line.domNode.classList.add("figure-caption");
      }
    },
  },
  {
    id: "footnote",
    name: LOCALIZED_TEXTS.styles.footnote,
    preview: "¹",
    description: "Note de bas de page",
    apply: (quill) => {
      const range = quill.getSelection(true);
      quill.removeFormat(range.index, range.length);
      quill.format("header", false);
      quill.format("size", "small");
      quill.format("color", "#6b7280");
      // Ajouter une classe CSS personnalisée
      const [line] = quill.getLine(range.index);
      if (line) {
        line.domNode.classList.add("footnote");
      }
    },
  },
];
